'use strict';

var cov_bkzpffjzq = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.autocompletes.factory.js',
        hash = '2283cdfe738cc28d53564cb5904eead124d1dc07',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.organization.autocompletes.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 38,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 63
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 38,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 37,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_bkzpffjzq.s[0]++;
(function () {
    'use strict';

    cov_bkzpffjzq.f[0]++;
    cov_bkzpffjzq.s[1]++;
    angular.module('app').factory('OrganizationAutocompletesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_bkzpffjzq.f[1]++;
        cov_bkzpffjzq.s[2]++;

        return restmod.model('/organization-autocompletes').mix('MixinContainable', {
            $config: {
                contains: {
                    organizationAutocompleteEconomicActivity: {
                        type: 'hasMany',
                        table: 'OrganizationAutocompleteEconomicActivitiesTable',
                        foreignKey: 'organization_autocomplete'
                    },
                    organizationAutocompletePeople: {
                        type: 'hasMany',
                        table: 'OrganizationAutocompletePeopleTable',
                        foreignKey: 'organization_autocomplete'
                    },
                    organizationAutocompleteLink: {
                        type: 'hasMany',
                        table: 'OrganizationAutocompleteLinkTable',
                        foreignKey: 'organization_autocomplete'
                    },
                    organizationAutocompleteEmail: {
                        type: 'hasMany',
                        table: 'OrganizationAutocompleteEmailTable',
                        foreignKey: 'organization_autocomplete'
                    }
                }
            }

        });
    }
})();